var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value?.proposalName)?_c(_vm.isLink ? 'a' : 'span',_vm._b({ref:"linkRef",tag:"component",staticClass:"proposal-name-link",attrs:{"draggable":"false"},domProps:{"innerHTML":_vm._s(_vm.highlight())},on:{"click":function($event){return _vm.handleClick($event)}}},'component',
    _vm.isLink
      ? {
          href: _vm.linkForProposal,
          target: '_blank',
          rel: 'noopener noreferrer',
        }
      : {}
  ,false)):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }